// API base URL 환경별 관리
// .env.development: 로컬 개발 환경 (http://localhost:8081)
// .env.production: AWS 운영 환경 (상대 경로, F/E와 같은 포트)
import axios from 'axios';
import { clearAuthStorage, isAuthRedirectExemptUrl } from '@/lib/authStorage';

// 환경 변수에서 읽어오며, 빈 값이면 상대 경로로 설정 (운영 환경)
const getApiBaseUrl = (): string => {
  const envUrl = process.env.REACT_APP_API_BASE_URL;
  
  // 환경 변수가 명시적으로 빈 문자열이거나 없는 경우 → 상대 경로 (운영)
  if (envUrl === '' || envUrl === undefined) {
    return '';
  }
  
  // 환경 변수에 값이 있는 경우 → 해당 URL 사용 (로컬)
  return envUrl;
};

export const API_BASE_URL = getApiBaseUrl();

// Google OAuth Client ID
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || '';

// 환경 정보
export const IS_PRODUCTION = process.env.NODE_ENV === 'production';
export const IS_DEVELOPMENT = process.env.NODE_ENV === 'development';

// 디버깅용 환경 정보 출력 (개발 환경에서만)
if (IS_DEVELOPMENT) {
  console.log('🔧 환경 설정:', {
    NODE_ENV: process.env.NODE_ENV,
    API_BASE_URL: API_BASE_URL || '(상대 경로)',
    GOOGLE_CLIENT_ID: GOOGLE_CLIENT_ID ? '설정됨' : '미설정',
  });
}

// ─── 공통 Axios 인스턴스 ────────────────────────────────────────────────────
// teamApi 등 신규 API 파일에서 사용. 개별 headers: getAuthHeaders() 불필요.

export const apiAxios = axios.create({
  baseURL: `${API_BASE_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
});

// 요청 인터셉터: Bearer 토큰 자동 주입
apiAxios.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken') || sessionStorage.getItem('authToken');
  if (token && config.headers) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 응답 인터셉터
apiAxios.interceptors.response.use(
  (response) => {
    // ApiResponse 구조에서 실제 데이터 추출
    if (response.data && response.data.success !== undefined) {
      response.data = response.data.data;
    }
    // B/E가 2xx + success:false 를 반환하는 경우 방어
    if (response.data && response.data.success === false) {
      return Promise.reject({ response: { status: response.status, data: response.data } });
    }
    return response;
  },
  (error) => {
    // 401 → 토큰 만료, 로그인 페이지로 이동 (단, skipAuthRedirect 플래그나 인증 전 단계
    // 요청이면 제외). AuthContext.tsx의 bare-axios 401 핸들러와 동일한 storage 정리를
    // 수행해 "토큰은 지워졌는데 유저 정보는 남아있는" 반쪽 로그아웃 상태를 없앤다.
    if (
      error.response?.status === 401 &&
      !(error.config as any)?._skipAuthRedirect &&
      !isAuthRedirectExemptUrl(error.config?.url)
    ) {
      clearAuthStorage();
      window.location.href = '/login?reason=unauthorized';
    }
    return Promise.reject(error);
  }
);

